import { size, spacing } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import styled from "styled-components";
import Button from "../../Button";
export const CopyButton = styled(Button) `
  && {
    margin-top: -${spacing.base.xs};
    padding: ${spacing.base.xs};

    svg {
      font-size: ${size.icon.s};
    }
  }
`;
export default CopyButton;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ29weUJ1dHRvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0NvcHlCdXR0b24vc3R5bGVkL0NvcHlCdXR0b24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLElBQUksRUFBRSxPQUFPLEVBQUUsTUFBTSxnREFBZ0QsQ0FBQztBQUMvRSxPQUFPLE1BQU0sTUFBTSxtQkFBbUIsQ0FBQztBQUN2QyxPQUFPLE1BQU0sTUFBTSxjQUFjLENBQUM7QUFFbEMsTUFBTSxDQUFDLE1BQU0sVUFBVSxHQUFHLE1BQU0sQ0FBQyxNQUFNLENBQUMsQ0FBQTs7bUJBRXJCLE9BQU8sQ0FBQyxJQUFJLENBQUMsRUFBRTtlQUNuQixPQUFPLENBQUMsSUFBSSxDQUFDLEVBQUU7OzttQkFHWCxJQUFJLENBQUMsSUFBSSxDQUFDLENBQUM7OztDQUc3QixDQUFDO0FBRUYsZUFBZSxVQUFVLENBQUMifQ==